/**
 SuperSelect class.  A more powerful encapsulation of HTML select components.
 [public methods]
 getOptionAt(index)
 getOption(optionValue)
 getSelectedOptions()
 getSelectedOption()
 clearSelections()
 appendOption(value, text)
 getOptions()
 getCount()
 selectInterval(fromIdx, toIdx)
 */
export class SuperSelect {
    constructor(selectElm) {
        this.sel = selectElm;
    }

    getOptionAt(index) {
        return new SelectOption(this.sel, this.sel.options[index].value);
    };

    getOption(optionValue) {
        //construct a SelectOption
        let opt = new SelectOption(this.sel, optionValue);
        //does the option value exist?
        if (opt.findOptionIndex() >= 0)
            return opt;
        else
            return null;
    };

    getSelectedOptions() {
        let result = new Array(0);
        let j = 0;
        let opts = this.sel.options;
        let len = opts.length;
        for (let i = 0; i < len; i++) {
            if (opts[i].selected) {
                result[j] = new SelectOption(this.sel, opts[i].value);//this.getOptionAt(i);
                j++;
            }
        }

        return result;
    };

    getSelectedOption() {
        let selectedOpts = this.getSelectedOptions();
        if (selectedOpts.length > 0)
            return selectedOpts[0];
        else
            return null;
    };

    clearSelections() {
        let opts = this.sel.options;
        let len = opts.length;
        for (let i = 0; i < len; i++)
            opts[i].selected = false;
    };

    appendOption(value, text) {
        this.sel.options[this.sel.length] = new Option(text, value);
    };

    /**append an existing Option() instance*/
    appendOpt(opt) {
        this.sel.options[this.sel.length] = opt;
    };

    getOptions() {
        let len = this.sel.options.length;
        let arr = new Array(len);

        for (let i = 0; i < len; i++)
            arr[i] = new SelectOption(this.sel, this.sel.options[i].value);

        return arr;
    };

    getCount() {
        return this.sel.options.length;
    };

    selectInterval(fromIdx, toIdx) {
        for (let i = fromIdx; i < toIdx; i++)
            this.sel.options[i].selected = true;
    };

    setAllSelected(selected) {
        let len = this.sel.options.length;
        for (let i = 0; i < len; i++)
            this.sel.options[i].selected = selected;
    };

    removeAll() {
        let len = this.sel.options.length;
        for (let i = len - 1; i >= 0; i--)
            this.sel.options[i] = null;
    };
}


/**
 SelectOption class.  Used by SuperSelect class.
 [public methods]
 getValue()
 getText()
 setValue(newValue)
 setText(newText)
 remove(): delete this option from the select.
 setSelected(selected): select or deselect this option
 getSelected(): returns true if the option is selected
 setAllSelected(bool): select or unselect all options
 */
class SelectOption {
    constructor(select, optVal) {
        this.sel = select;
        this.optValue = optVal;
    }

    getValue() {
        let idx = this.findOptionIndex();
        return this.sel.options[idx].value;
    };

    getText() {
        let idx = this.findOptionIndex();
        return this.sel.options[idx].text;
    };

    setValue(newValue) {
        let idx = this.findOptionIndex();
        this.sel.options[idx].value = newValue;
    };

    setText(newText) {
        let idx = this.findOptionIndex();
        this.sel.options[idx].text = newText;
    };

    remove() {
        let idx = this.findOptionIndex();
        this.sel.options[idx] = null;

        //invalidate this option
        this.sel = null;
        this.optValue = null;
    };

    setSelected(selected) {
        let idx = this.findOptionIndex();
        this.sel.options[idx].selected = selected;
    };

    getSelected() {
        let idx = this.findOptionIndex();
        return this.sel.options[idx].selected;
    };

    findOptionIndex() {
        let opts = this.sel.options;
        for (let i = 0; i < opts.length; i++) {
            if (opts[i].value == this.optValue) {
                return i;
            }
        }

        return -1;
    };
}